import React from 'react';
import { Bubble } from 'tea-component';
import TableSelect from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/Financials/components/TableSelect';
import '@/pages/intelligence/assets/scss/TopCharts/Companies/GamesDetails/financials.scss';
import { unitConversion } from '@/pages/dashboard/utils/utils';
import _ from 'lodash-es';
export const investmentsTableData = (
  cvmList: { [key: string]: unknown }[],
  paramsDefault: { [key in string]: unknown },
  DropdownList: any[],
  setParamsDefault: (...args: any) => void | Function,
  formatMessage: any,
) => {
  const [organizationList = [], fundingRoundList = [], moneyRaisedList = []] =
    DropdownList;
  const handleOnSort = _.throttle(<T,>(key?: T, value?: any) => {
    setParamsDefault((pre: any) => ({
      ...pre,
      [key]: value,
      page: 1,
    }));
  }, 300);

  return {
    cvmList: cvmList || [],
    columns: [
      {
        key: 'announced_on',
        header: (
          <Bubble
            content={formatMessage({ id: 'dbi_company_announced_date' })}
            dark
          >
            <span>{formatMessage({ id: 'dbi_company_announced_date' })}</span>
          </Bubble>
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.announce_date}</div>
        ),
      },
      {
        key: 'Organization Name',
        header: (
          <TableSelect
            title={formatMessage({ id: 'dbi_company_organization_name' })}
            onChange={(value: any) => handleOnSort('name', value)}
            checkList={organizationList}
          />
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.organization_name}</div>
        ),
      },
      {
        key: 'Lead Investor',
        header: (
          <TableSelect
            type="Radio"
            title={formatMessage({ id: 'dbi_company_lead_investor' })}
            nosearch={true}
            onChange={(value: any) => handleOnSort('lead_investor', value)}
            isAll={false}
            checkList={[
              {
                name: '2',
                text: 'All',
              },
              {
                name: '1',
                text: 'Yes',
              },
              {
                name: '0',
                text: 'No',
              },
            ]}
          />
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.lead_investor}</div>
        ),
      },
      {
        key: 'Founding Round',
        header: (
          <TableSelect
            title={formatMessage({ id: 'dbi_company_founding_round' })}
            checkList={fundingRoundList}
            onChange={(value: any) => handleOnSort('funding_round', value)}
          />
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.funding_round}</div>
        ),
      },
      {
        key: 'Money Raised',
        header: (
          <TableSelect
            checkList={moneyRaisedList}
            title={formatMessage({ id: 'dbi_company_money' })}
            onChange={(value: any) =>
              handleOnSort('money_raised', value?.join())
            }
          />
        ),
        align: 'right',
        render: (cvm: any) => (
          <div className="table-text">{unitConversion(cvm.money_raised)}</div>
        ),
      },
    ],
    addonscolumns: ['announced_on'],
  };
};
export const investorsTableData = (
  ...[
    cvmList,
    paramsDefault,
    DropdownList,
    setParamsDefault,
    formatMessage,
  ]: Parameters<typeof investmentsTableData>
) => {
  const [investorNameList = [], fundingRoundList = [], partnersList = []] =
    DropdownList;
  const handleOnSort = _.throttle(<T extends string>(key: T, value?: any) => {
    setParamsDefault(<T extends { [key: string]: any }>(pre: T) => ({
      ...pre,
      [key]: value,
      page: 1,
    }));
  }, 300);
  return {
    cvmList: cvmList || [],
    columns: [
      {
        key: 'Investors Name',
        header: (
          <TableSelect
            title={formatMessage({ id: 'dbi_company_investors_name' })}
            checkList={investorNameList}
            onChange={(value: any) => handleOnSort('investor_name', value)}
          />
        ),
        align: 'left',
        render: (cvm: any) => <div className="table-text">{cvm.investor}</div>,
      },
      {
        key: 'Lead Investor',
        header: (
          <TableSelect
            title={formatMessage({ id: 'dbi_company_lead_investor' })}
            type="Radio"
            nosearch={true}
            onChange={(value: any) => handleOnSort('lead_investor', value)}
            isAll={false}
            checkList={[
              {
                name: '2',
                text: 'All',
              },
              {
                name: '1',
                text: 'Yes',
              },
              {
                name: '0',
                text: 'No',
              },
            ]}
          />
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.is_lead_investor}</div>
        ),
      },
      {
        key: 'Founding Round',
        header: (
          <TableSelect
            title={formatMessage({ id: 'dbi_company_founding_round' })}
            onChange={(value: any) =>
              handleOnSort('funding_round_identifier_value', value)
            }
            checkList={fundingRoundList}
          />
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.funding_round_identifier_value}</div>
        ),
      },
      {
        key: 'Partners',
        header: (
          <TableSelect
            title={formatMessage({ id: 'dbi_company_partners' })}
            checkList={partnersList}
            onChange={(value: any) => handleOnSort('partners', value)}
          />
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.partner_identifiers_value}</div>
        ),
      },
    ],
    addonscolumns: [],
  };
};

export const fundingroundsTableData = (
  ...[
    cvmList,
    paramsDefault,
    DropdownList,
    setParamsDefault,
    formatMessage,
  ]: Parameters<typeof investmentsTableData>
) => {
  const [transactionNameList = [], leadInvestorList = []] = DropdownList;
  const handleOnSort = _.throttle(<T extends string>(key: T, value?: any) => {
    setParamsDefault((pre: any) => ({
      ...pre,
      [key]: value,
      page: 1,
    }));
  }, 300);

  return {
    cvmList: cvmList || [],
    columns: [
      {
        key: 'announced_on',
        header: (
          <Bubble
            content={formatMessage({ id: 'dbi_company_announced_date' })}
            dark
          >
            <span>{formatMessage({ id: 'dbi_company_announced_date' })}</span>
          </Bubble>
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.announced_on}</div>
        ),
      },
      {
        key: 'Transaction Name',
        header: (
          <TableSelect
            title={formatMessage({ id: 'dbi_company_transaction_name' })}
            onChange={(value: any) => handleOnSort('transaction_name', value)}
            checkList={transactionNameList}
          />
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.transaction_name}</div>
        ),
      },
      {
        key: 'num_investors',
        header: (
          <Bubble
            content={formatMessage({ id: 'dbi_company_number_investors' })}
            dark
          >
            <span
              onClick={() => {
                // console.log(223);
              }}
            >
              {formatMessage({ id: 'dbi_company_number_investors' })}
            </span>
          </Bubble>
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.num_investors}</div>
        ),
      },
      {
        key: 'money_raised',
        header: (
          <Bubble content={formatMessage({ id: 'dbi_company_money' })} dark>
            <span>{formatMessage({ id: 'dbi_company_money' })}</span>
          </Bubble>
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{unitConversion(cvm.money_raised)}</div>
        ),
      },
      {
        key: 'Lead Investor',
        header: (
          <TableSelect
            title={formatMessage({ id: 'dbi_company_lead_investor' })}
            onChange={(value: any) => handleOnSort('lead_investors', value)}
            checkList={leadInvestorList}
          />
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.lead_investor}</div>
        ),
      },
    ],
    addonscolumns: ['announced_on', 'num_investors', 'money_raised'],
  };
};

export const acquisitionsTableData = (
  ...[
    cvmList,
    paramsDefault,
    DropdownList,
    setParamsDefault,
    formatMessage,
  ]: Parameters<typeof investmentsTableData>
) => {
  const [acquireeNameList = [], transactionNameList = []] = DropdownList;
  const handleOnSort = _.throttle((key: string, value?: any) => {
    // const sortType = isSortFn(key)
    setParamsDefault((pre: any) => ({
      ...pre,
      [key]: value,
      page: 1,
    }));
  }, 300);

  return {
    cvmList: cvmList || [],
    columns: [
      {
        key: 'Acquiree Name',
        header: (
          <TableSelect
            title={formatMessage({ id: 'dbi_company_acquiree_name' })}
            onChange={(value: any) => handleOnSort('acquiree_name', value)}
            checkList={acquireeNameList}
          />
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.acquiree_name}</div>
        ),
      },
      {
        key: 'announced_on',
        header: (
          <Bubble
            content={formatMessage({ id: 'dbi_company_announced_date' })}
            dark
          >
            <span> {formatMessage({ id: 'dbi_company_announced_date' })}</span>
          </Bubble>
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.announces_date}</div>
        ),
      },
      {
        key: 'price',
        header: (
          <Bubble content={formatMessage({ id: 'dbi_company_price' })} dark>
            <span> {formatMessage({ id: 'dbi_company_price' })} </span>
          </Bubble>
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{unitConversion(cvm.price)}</div>
        ),
      },
      {
        key: 'Transaction Name',
        header: (
          <TableSelect
            title={formatMessage({ id: 'dbi_company_transaction_name' })}
            onChange={(value: any) => handleOnSort('transaction_name', value)}
            checkList={transactionNameList}
          />
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.transaction_name}</div>
        ),
      },
    ],
    addonscolumns: ['announced_on', 'price'],
  };
};
